import { render, staticRenderFns } from "./TempConfigCostCategoryModal.vue?vue&type=template&id=5c88af2c&scoped=true"
import script from "./TempConfigCostCategoryModal.vue?vue&type=script&lang=js"
export * from "./TempConfigCostCategoryModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c88af2c",
  null
  
)

export default component.exports